// Přepisy obrázků webu z adminu. img(key, default) vrací nahranou URL nebo default.
export const IMG = { map: {} };

export function setImages(map) {
  IMG.map = map || {};
}

export function img(key, fallback) {
  const v = IMG.map[key];
  return (v === undefined || v === null || v === "") ? fallback : v;
}
